class Accordion {

    // Special Version for Markant 

    constructor(selector) {
        this.selector = selector;
        this.accordions = document.querySelectorAll(selector);
    }

    setInertState(element, isInert) {
        const content = element.lastElementChild;
        if (isInert) {
            content.setAttribute('inert', '');
        } else {
            content.removeAttribute('inert');
        }
    }

    toggleAccordion(clickedAccordion) {
        const isClosed = !clickedAccordion.classList.contains('js-accordion--opened');

        console.log('toggle', clickedAccordion, isClosed);

        if (isClosed) {
            clickedAccordion.classList.add('js-accordion--opened');
            clickedAccordion.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'true');
            this.setInertState(clickedAccordion, false);
        } else {
            clickedAccordion.classList.remove('js-accordion--opened');
            clickedAccordion.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'false');
            this.setInertState(clickedAccordion, true);
        }
    }

    initClickHandler() {
        document.addEventListener('click', (e) => {
            const accordion   = e.target?.closest(this.selector);
            const buttonClickedv1 = e.target.closest('button[aria-expanded]');
            const buttonClickedv2 = e.target.querySelector('button[aria-expanded]');

            if (!accordion || !buttonClickedv1 && !buttonClickedv2)  return;

            this.toggleAccordion(accordion);
        });
    }

    init() {
        this.accordions.forEach(el => this.setInertState(el, true));
        this.initClickHandler();
    }
}

export const initAccordion = (selector) => {
    new Accordion(selector).init();
};
